
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M5.5 20h21L30 30H2l3.5-10z","fill":"#fff","stroke":"#393939","stroke-linejoin":"round"}}),_c('rect',{attrs:{"x":"17.081","y":"11.868","width":"4.719","height":"13.098","rx":"2.36","transform":"rotate(30 17.081 11.868)","fill":"#1BBAC8","stroke":"#393939"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.155 15.873a8.007 8.007 0 108.007-13.87 8.007 8.007 0 00-8.007 13.87zm1.714-2.972a4.576 4.576 0 104.576-7.925 4.576 4.576 0 00-4.576 7.925z","fill":"#1BBAC8"}}),_c('path',{attrs:{"d":"M28.66 12.692a7.507 7.507 0 01-10.255 2.748l-.5.866a8.507 8.507 0 0011.62-3.114l-.865-.5zM25.912 2.437a7.507 7.507 0 012.748 10.255l.866.5A8.507 8.507 0 0026.412 1.57l-.5.866zM15.657 5.185a7.507 7.507 0 0110.255-2.748l.5-.866a8.507 8.507 0 00-11.621 3.114l.866.5zm2.748 10.255a7.507 7.507 0 01-2.748-10.255l-.866-.5a8.507 8.507 0 003.114 11.62l.5-.865zm7.282-4.464a4.076 4.076 0 01-5.568 1.492l-.5.866a5.076 5.076 0 006.934-1.858l-.866-.5zm-1.492-5.567a4.076 4.076 0 011.492 5.567l.866.5a5.076 5.076 0 00-1.858-6.933l-.5.866zM18.628 6.9a4.076 4.076 0 015.567-1.491l.5-.866A5.076 5.076 0 0017.762 6.4l.866.5zm1.491 5.568A4.076 4.076 0 0118.628 6.9l-.866-.5a5.076 5.076 0 001.857 6.934l.5-.866z","fill":"#393939"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}})])])])
          )
        }
      }
    